import { Component, OnInit } from "@angular/core";
import { Product } from "src/app/api/models";
import { RetrieveService } from "src/app/api/services";
import { map } from "rxjs/operators";
import { ProductService } from "src/app/shared/services/product.service";

@Component({
  selector: "app-best-product",
  templateUrl: "./best-product.component.html",
  styleUrls: ["./best-product.component.scss"],
})
export class BestProductComponent implements OnInit {
  bestProducts: Product[] = [];
  options = {
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:5,
            nav:true,
            loop:false
        }
    }
  }
  loading = false;
  constructor(
    private retrieveService: RetrieveService,
    private productService: ProductService,
  ) {}

  ngOnInit() {
    this.getAllProducts();
  }

  getAllProducts() {
    this.loading = true;
    const x = this.retrieveService.getProducts({offset:0 , limit: 12, category: 1, quantityFrom: 1});
    x.subscribe(
      (product) => {
        this.loading = false;
        this.bestProducts = [];
        product.forEach((element) => {
          this.bestProducts.push(element as Product);
        });
      },
      (err) => {
      }
    );
  }

  addToCart(product: Product) {
    this.productService.addToCart(product);
  }
}
